import React from 'react'
import "./Socials.css"

import X1app from "../../assets/X1.png"
import Xapp from "../../assets/X.png"
import { BsGithub } from "react-icons/bs";
import { BsDiscord } from 'react-icons/bs';
import { FaHashnode } from "react-icons/fa6";
import useLocalStorage from 'use-local-storage';


const Socials = () => {
    const [theme, setTheme] = useLocalStorage('theme' ? 'dark': 'light')

    const themeSwitch = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme)
    }
    console.log(themeSwitch)

  return (
    <div className='socials_container'>
        <div className='socials_inner_div'>
            <span className=''><a href='https://github.com/uakubue'><BsGithub /></a></span>
            <span className=''>
                <a href='https://twitter.com/holmesakubue'>
                {
                    theme === "dark" ? <img src={X1app} width={30} alt='Twitter'/> : <img src={Xapp} width={30} alt='Twitter'/>
                }
                </a>
            </span>
            <span className=''><a href='https://discord.com/channels/@me'><BsDiscord /></a></span>
            <span className=''><a href='https://cholantechsolutions.hashnode.dev/'><FaHashnode /></a></span>
            {/* <li className='D'><a href='https://wa.me/08131890974?text=Hello,%20I%20want%20to%20know%20more%20about%20your%20services,%20can%20you%20help%20me?.'><BsWhatsapp /></a></li> */}
        </div>
    </div>
  )
}

export default Socials